import { cn } from "@vidario/ui";
import { Grid3x3, List } from "lucide-react";
import { type ReactElement } from "react";

export type DashboardView = "cards" | "table";

export interface ViewToggleProps {
  value: DashboardView;
  onChange: (value: DashboardView) => void;
}

const OPTIONS: { id: DashboardView; label: string; Icon: typeof Grid3x3 }[] = [
  { id: "cards", label: "Kartenansicht", Icon: Grid3x3 },
  { id: "table", label: "Tabellenansicht", Icon: List },
];

/** Tight two-button segmented control used by the Dashboard to switch
 * between the card grid and the table view. */
export function ViewToggle({ value, onChange }: ViewToggleProps): ReactElement {
  return (
    <div
      role="radiogroup"
      aria-label="Ansicht"
      className="inline-flex h-10 items-center gap-0.5 rounded-md border border-border-default bg-neutral-0 p-0.5"
    >
      {OPTIONS.map(({ id, label, Icon }) => {
        const active = id === value;
        return (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={active ? "true" : "false"}
            aria-label={label}
            onClick={() => onChange(id)}
            className={cn(
              "inline-flex h-8.5 w-9 items-center justify-center rounded-[5px] transition-colors",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500",
              active
                ? "bg-primary-50 text-primary-700"
                : "text-neutral-500 hover:text-neutral-800",
            )}
          >
            <Icon size={15} />
          </button>
        );
      })}
    </div>
  );
}
